import { render, staticRenderFns } from "./xScroll.vue?vue&type=template&id=0e936409&"
import script from "./xScroll.vue?vue&type=script&lang=js&"
export * from "./xScroll.vue?vue&type=script&lang=js&"
import style0 from "./xScroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports